export default __webpack_public_path__ + "static/media/bankID.72b8679e.svg";